import React, { forwardRef } from 'react';
import { styled } from 'styled-components';
import { xLargeRange } from '../../../../play-core/styles/Viewports';
import { containerPadding, containerWidth } from '../PlayContainer/PlayContainer';
import { jsx as _jsx } from "react/jsx-runtime";
export const SwipeableContainer = /*#__PURE__*/forwardRef(({
  children
}, ref) => /*#__PURE__*/_jsx(Container, {
  children: /*#__PURE__*/_jsx(ContentContainer, {
    ref: ref,
    children: children
  })
}));
export const Container = styled.div.withConfig({
  displayName: "SwipeableContainer__Container",
  componentId: "sc-y6k3mt-0"
})(["display:flex;justify-content:center;@media only screen and (min-width:", "px){max-width:", "px;margin:auto;display:grid;grid-template-columns:1fr ", "px 1fr;}"], containerWidth.default, containerWidth.max, containerWidth.default - 2 * containerPadding.large);
export const ContentContainer = styled.div.withConfig({
  displayName: "SwipeableContainer__ContentContainer",
  componentId: "sc-y6k3mt-1"
})(["position:relative;overflow:hidden;width:100%;@media only screen and (min-width:", "px) and (max-width:", "px){padding-left:", "px;}@media only screen and (min-width:", "px){grid-column:2/4;grid-row:1;}"], xLargeRange.from, containerWidth.default - 1, containerPadding.large, containerWidth.default);